import { ToastPosition } from "@chakra-ui/react";

export const toastOptions = {
  defaultOptions: {
    position: "top" as ToastPosition,
    duration: 3000,
    isClosable: true,
  },
};

/**
 * Configuration for reminder cooldown periods.
 * Tasks/stakeholders reminded within this window are considered "recently reminded".
 */
export const reminderConfig = {
  /** Number of hours before a reminder is no longer considered "recent" */
  recentlyRemindedWindowHours: 24,
};

/**
 * Standard modal dimensions for consistent UI.
 */
export const modalDimensions = {
  /** Large modal with sidebar (e.g., Send Reminders Queue) */
  large: {
    maxWidth: "1100px",
    height: "700px",
    maxHeight: "90vh",
  },
};
